// extracted by mini-css-extract-plugin
module.exports = {"footer":"FuwFooter_footer__129Cw","text":"FuwFooter_text__1zoL9"};